import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { LetterService } from '@schoolbelle/api/letter';
import { ReadListModalService } from './read-list.service';
import { LetterReadTableService, ReadTableRowData } from '@schoolbelle/api/letter-read';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';

@Injectable({
  providedIn:'root',
})
export class ReadListResolve implements Resolve<{letter:LetterOnBoard, rows:ReadTableRowData[]}> {

  constructor(
    protected letter:LetterService,
    protected readListModalService:ReadListModalService,
    protected letterReadTable: LetterReadTableService,
  ) {
  }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return of({
      letter:this.letterReadTable.letter,
      rows:this.letterReadTable.readTableRows,
    });
  }
}
